import socketIOClient from 'socket.io-client'

class SocketEventHandler {
    constructor(socketOptions, callback) {
        this.socket = socketIOClient('/', socketOptions)

        this.socket.on('connect', data => {
            console.log('CONNECTED TO SOCKET!')
            callback('reconnect', data)
        })

        this.socket.on('message-receive', data => {
            console.log('[MESSAGE RECEIVED]')
            callback('message-receive', data)
        })

        this.socket.on('user-info', data => {
            callback('user-info', data)
        })

        this.socket.on('dialogue-handler', data => {
            callback('dialogue-handler', data)
        })

        this.socket.on('timer-event', () => {
            // console.log('timer-event', data)
        })

        this.socket.on('disconnect', data => {
            console.log('DISCONNECTED FROM SOCKET!')
            callback('disconnect', data)
        })

        this.socket.on('reconnect', data => {
            console.log('RECONNECTED TO SOCKET!')
            callback('reconnect', data)
        })
    }

    emitEvent(event, data) {
        this.socket.emit(event, data)
    }
}

export default SocketEventHandler
